import React from 'react';
import { ArrowRight, HeartHandshake, LayoutDashboard, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface ProgramHeroPreviewProps {
  onOpenPreview: () => void;
}

const ProgramHeroPreview: React.FC<ProgramHeroPreviewProps> = ({ onOpenPreview }) => {
  const { t } = useTranslation();
  const previewItems = [
    {
      icon: LayoutDashboard,
      title: t('programHeroCohortSignalTitle'),
      description: t('programHeroCohortSignalDesc'),
    },
    {
      icon: Users,
      title: t('programHeroSupportPriorityTitle'),
      description: t('programHeroSupportPriorityDesc'),
    },
    {
      icon: HeartHandshake,
      title: t('programHeroPartnerContextTitle'),
      description: t('programHeroPartnerContextDesc'),
    },
  ];

  return (
    <section className="hero-demo-box hero-program-preview" aria-labelledby="program-preview-title">
      <div className="hero-demo-badge">{t('programHeroPreviewBadge')}</div>
      <div className="hero-program-preview-header">
        <h3 id="program-preview-title">{t('programHeroPreviewTitle')}</h3>
        <p>{t('programHeroPreviewDescription')}</p>
      </div>

      <div className="hero-program-preview-list">
        {previewItems.map(({ icon: Icon, title, description }) => (
          <div className="hero-program-preview-item" key={title}>
            <Icon size={20} aria-hidden="true" />
            <div>
              <strong>{title}</strong>
              <span className="hero-program-preview-description">{description}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="hero-program-actions">
        <button type="button" className="hero-demo-submit" onClick={onOpenPreview}>
          {t('programHeroPreviewCta')}
          <ArrowRight size={18} aria-hidden="true" />
        </button>
        <Link className="hero-program-contact-link" to="/programs#programs-pilot-form">
          {t('programsPageFormSubmit')}
          <ArrowRight size={16} aria-hidden="true" />
        </Link>
      </div>
      <p className="hero-demo-footer">{t('programHeroPreviewFootnote')}</p>
    </section>
  );
};

export default ProgramHeroPreview;
